import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { cn, putClientRelationshipStageByClientIdRequest } from '..';
import { useDispatch } from 'react-redux';

export type ClientRelationshipStageWithUndefined =
  | ClientRelationshipStage
  | 'undefined';

const relationshipStages: Record<ClientRelationshipStageWithUndefined, string> =
  {
    undefined: 'Undefined',
    lead: 'Lead',
    client: 'Client',
    prospect: 'Prospect',
    partner: 'Partner',
    alumni: 'Alumni',
  };

const stageColorMap: Record<ClientRelationshipStageWithUndefined, string> = {
  undefined: 'bg-gray-400',
  lead: 'bg-yellow-400',
  client: 'bg-green-400',
  prospect: 'bg-blue-400',
  partner: 'bg-violet-400',
  alumni: 'bg-orange-400',
};

interface SelectClientRelationshipStageMenuProps {
  clientRelationshipStage: ClientRelationshipStage | undefined;
  client?: Client;
  onChange?: (value: ClientRelationshipStageWithUndefined) => void;
  triggerClassName?: string;
}

export function SelectClientRelationshipStage({
  clientRelationshipStage,
  client,
  onChange,
  triggerClassName,
}: SelectClientRelationshipStageMenuProps) {
  const dispatch = useDispatch();

  const handleOnChange = onChange
    ? onChange
    : (value: ClientRelationshipStageWithUndefined) => {
        if (!client) return;
        dispatch(
          putClientRelationshipStageByClientIdRequest({
            clientId: client.clientId,
            relationshipStage: value === 'undefined' ? undefined : value,
          }),
        );
      };

  const stage = clientRelationshipStage ?? 'undefined';
  return (
    <Select
      value={stage}
      onValueChange={handleOnChange}
    >
      <SelectTrigger
        className={cn(triggerClassName)}
        data-testid="assign-type-trigger"
      >
        <SelectValue className="p-0">
          <div className="flex items-center gap-2">
            <div
              className={cn(
                'h-2 w-2 shrink-0 rounded-full text-sm',
                stageColorMap[stage],
              )}
            />
            {relationshipStages[stage]}
          </div>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {Object.entries(relationshipStages).map(([stage, label]) => (
          <SelectItem
            key={stage}
            value={stage}
            indicatorPosition="right"
            itemIndicatorClassName="h-3 w-3"
            className="hover:bg-gray-100"
            data-testid={`assign-type-option-${stage}`}
          >
            <div className="flex items-center gap-2">
              <div
                className={cn(
                  'h-2 w-2 shrink-0 rounded-full text-sm',
                  stageColorMap[stage as ClientRelationshipStage],
                )}
              />
              {relationshipStages[stage as ClientRelationshipStage]}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
